import React from 'react'

export default function Decoration({ event, className, ...props }) {
 
  return (
    <div {...props} className={'event-card mb-[20px] md:mb-[15px] md:hidden  ' + className}>
      <div className="  z-20 flex justify-center items-center pixel h3 text-center bg-image">
        {event.name}
      </div>
      <img alt='' className={'z-10  flex flex-col justify-center items-center  relative ' } src={event.backgroundImage.url} />
    </div>
  )
}
